import { render, staticRenderFns } from "./DerivativesFilters.vue?vue&type=template&id=455fc943&scoped=true"
import script from "./DerivativesFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./DerivativesFilters.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DerivativesFilters.vue?vue&type=style&index=0&id=455fc943&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455fc943",
  null
  
)

export default component.exports